const STATUS_TOGGLE = {
  Available: "Occupied",
  Occupied: "Available",
  Maintenance: "Available",
};

// The nullish coalescing operator (??) checks whether its left side is null or undefined
// If STATUS_TOGGLE[status] is null or undefined, it instead evaluates to the right-hand side

// "Available" returns "Occupied"
// "Unknown" returns "Unknown" (STATUS_TOGGLE["Unknown"] yields undefined)

export const toggleStatus = (status) => STATUS_TOGGLE[status] ?? status;
